<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Contact Us</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.model" class="form-wrapper">
                <form-group label="Name" name="fullName">
                    <md-input v-model="model.fullName" />
                </form-group>
                <form-group label="Phone" name="phone">
                    <md-input v-model="model.phone" />
                </form-group>
                <form-group label="Email" name="email">
                    <md-input v-model="model.email" />
                </form-group>
                <form-group label="Message" name="message">
                    <md-textarea v-model="model.message" />
                </form-group>
            </form-wrapper>

            <div class="modal-footer">
                <md-button class="dialog-button md-primary" @click="send">
                    Send
                </md-button>
                <md-button class="dialog-button md-default" @click.stop="$modal.hide">
                    Cancel
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'ContactUs',
    mixins: [GeneralMixin],
    data() {
        return {
            model: {
                fullName: null,
                phone: null,
                email: null,
                message: null
            }
        };
    },

    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    validations() {
        return {
            model: {
                fullName: { required },
                phone: { required },
                email: { required },
                message: { required }
            }
        };
    },
    methods: {
        async send() {
            this.$v.model.$touch();

            if (this.$v.model.$invalid) 
                return;

            this.$_handleLoaderState(true, 'SENDING MESSAGE...');

            const payload = {
                method: 'post',
                data: {
                    ...this.model
                }
            };
            try {
                const api = `/api/alerts/send`;
                await handleRequests(api, payload);

                this.$notify({
                    message: 'Message sending successful.',
                    type: 'success'
                });
            } catch (e) {
                const message = 'Error sending message.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        }
    },
    mounted() {
        const { fullName, phone, email } = this.user;
        this.model = {
            fullName,
            phone,
            email,
            message: null
        };
    }
};
</script>
